import type { CssGeneratorContext } from '../css-generator.model';

/** Read-only server-generated preset text shown above the conclusion-step textareas.
 * Plain multi-line string — newlines and tab indentation preserved. */
export const styles = ({ dt }: CssGeneratorContext) => `
.preset-text {
  display: block;
  white-space: pre-wrap;
  text-align: justify;
  font-size: ${dt('presetText.text.fontSize')} !important;
  font-weight: ${dt('presetText.text.fontWeight')} !important;
  line-height: ${dt('presetText.text.lineHeight')} !important;
  color: ${dt('presetText.text.color')} !important;
}
`;
